import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CustomReports } from './CustomReports';
import useGmdUserInfo from '../../hooks/gmdUserInfo';

const ReportLoader = (props: any) => {
  const { userInfo } = useGmdUserInfo();
  const params = useParams();
  const { reportid } = params;

  const [reportLoaded, setReportLoaded] = useState<Boolean>(false);
  const [ReportContainer, setReportContainer] =
    useState<React.ComponentType | null>(null);

  const [report] = useState(
    CustomReports.find((rpt) => rpt.reportId === reportid)
  );

  useEffect(() => {
    if (report && !reportLoaded) {
      const reportPath = `./${report.reportContainer}`;
      import(`${reportPath}`)
        .then((component) => {
          setReportContainer(() => component.default);
          setReportLoaded(true);
        })
        .catch((error) => {
          console.error(error);
          setReportContainer(null);
        });
    }
  }, [report, reportLoaded]);

  return (
    <React.Fragment>
      {userInfo && ReportContainer && (
        <ReportContainer {...props} params={params} user={userInfo} />
      )}
    </React.Fragment>
  );
};

export default ReportLoader;
